import script from "./GoogleAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleAddress.vue?vue&type=script&setup=true&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./GoogleAddress.vue?vue&type=style&index=1&id=c216f89c&lang=scss"

const __exports__ = script;

export default __exports__